(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('.header-banner-countdown');
  if (!banner) return;
  const countdownEl = banner.querySelector('.countdown');
  if (!countdownEl) return;

  // Robust date parser for "YYYY-MM-DD HH:MM:SS" (local time)
  function parseDateTimeLocal(str) {
    if (!str) return null;
    const m = str.trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/);
    if (m) {
      const y = +m[1], mo = +m[2] - 1, d = +m[3];
      const hh = +(m[4] || 0), mm = +(m[5] || 0), ss = +(m[6] || 0);
      return new Date(y, mo, d, hh, mm, ss); // local time
    }
    const parsed = new Date(str);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  // Apply dynamic sizing & colors (from theme settings)
  const fontSize = parseInt(countdownEl.dataset.font, 10) || 18;
  const bg = countdownEl.dataset.bg || '#000';
  const color = countdownEl.dataset.color || '#fff';
  countdownEl.querySelectorAll('.countdown-value').forEach(el => {
    el.style.fontSize = fontSize + 'px';
    el.style.backgroundColor = bg;
    el.style.color = color;
  });
  countdownEl.querySelectorAll('.countdown-label').forEach(el => el.style.color = color);

  // Compute end date:
  let endDate = null;
  const hoursFromNow = parseInt(countdownEl.dataset.hours, 10) || 0;
  if (hoursFromNow > 0) {
    endDate = new Date(Date.now() + hoursFromNow * 60 * 60 * 1000);
  } else if (countdownEl.dataset.end) {
    endDate = parseDateTimeLocal(countdownEl.dataset.end);
  }
  if (!endDate || isNaN(endDate.getTime())) {
    // invalid end date -> hide countdown or set zeros
    console.warn('Countdown: invalid end date');
    countdownEl.querySelectorAll('.countdown-value').forEach(el => el.textContent = '00');
    return;
  }

  function updateCountdown() {
    const now = Date.now();
    const distanceMs = endDate.getTime() - now;
    const values = countdownEl.querySelectorAll('.countdown-value');

    if (distanceMs <= 0) {
      // expired
      if (banner.dataset.hide === "true") {
        banner.style.display = 'none';
      } else {
        values.forEach(el => el.textContent = '00');
      }
      clearInterval(timer);
      return;
    }

    const totalSeconds = Math.floor(distanceMs / 1000);
    const totalHours = Math.floor(totalSeconds / 3600);              // total hours (can be >24)
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    values[0].textContent = String(totalHours).padStart(2, '0');
    values[1].textContent = String(minutes).padStart(2, '0');
    values[2].textContent = String(seconds).padStart(2, '0');
  }

  updateCountdown();
  const timer = setInterval(updateCountdown, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-popup"] && !window.DesignMode) return;
  try {
    
window.addEventListener('load', function() {
  // console.log("✅ Page fully loaded, running popup script...");

  const popup = document.getElementById('homepage-popup');
  if (!popup) return;

  // only show on homepage
  if (window.location.pathname !== '/' && !window.location.pathname.includes('index')) return;

  // prevent multiple times in same session
  if (sessionStorage.getItem('homepagePopupShown')) return;

  // ensure inline display:none doesn’t block
  popup.style.display = '';

  // get delay from settings
  const delay = Number("{{ section.settings.popup_delay | default: 3 }}");

  // show popup after full load + delay
  setTimeout(() => {
    popup.classList.add('active');
    sessionStorage.setItem('homepagePopupShown', 'true');
    // console.log("✅ Popup displayed after page load + " + delay + "s delay.");
  }, delay * 1000);

  // close events
  popup.querySelector('.popup-close').addEventListener('click', () => popup.classList.remove('active'));
  popup.querySelector('.popup-overlay').addEventListener('click', () => popup.classList.remove('active'));

  // countdown logic
  const countdownEl = popup.querySelector('.popup-countdown');
  const endDate = new Date(countdownEl.dataset.end);
  const values = countdownEl.querySelectorAll('.popup-countdown-value');
  const bg = countdownEl.dataset.bg, color = countdownEl.dataset.color, fontSize = countdownEl.dataset.font;
  values.forEach(el => { el.style.backgroundColor = bg; el.style.color = color; el.style.fontSize = fontSize + 'px'; });

  function updateCountdown() {
    const now = Date.now();
    const diff = endDate - now;
    if (diff <= 0) { values.forEach(v => v.textContent = '00'); return; }
    const totalSecs = Math.floor(diff / 1000);
    const hrs = Math.floor(totalSecs / 3600);
    const mins = Math.floor((totalSecs % 3600) / 60);
    const secs = totalSecs % 60;
    values[0].textContent = String(hrs).padStart(2, '0');
    values[1].textContent = String(mins).padStart(2, '0');
    values[2].textContent = String(secs).padStart(2, '0');
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
